The identifier of the SEEK hirer that owns the position.

Their name will be displayed on the SEEK authorization page (i.e. "Partner Name on behalf of Hirer Name").
